var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeCheck20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "badge-check",
    clipPath: "url(#clip0_0_177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.50029 9.99926L9.16695 11.6659L12.5003 8.3326M3.20878 7.18268C3.08715 6.63478 3.10582 6.06505 3.26308 5.5263C3.42033 4.98754 3.71107 4.49722 4.10834 4.10078C4.5056 3.70434 4.99654 3.41463 5.53562 3.25851C6.0747 3.10238 6.64447 3.0849 7.19211 3.20768C7.49354 2.73626 7.90878 2.34831 8.39957 2.07958C8.89036 1.81086 9.4409 1.67 10.0004 1.67C10.56 1.67 11.1105 1.81086 11.6013 2.07958C12.0921 2.34831 12.5074 2.73626 12.8088 3.20768C13.3573 3.08437 13.928 3.10177 14.4679 3.25827C15.0079 3.41478 15.4995 3.7053 15.897 4.10281C16.2945 4.50032 16.585 4.99191 16.7415 5.53185C16.898 6.07179 16.9154 6.64254 16.7921 7.19101C17.2635 7.49244 17.6515 7.90768 17.9202 8.39847C18.1889 8.88926 18.3298 9.4398 18.3298 9.99935C18.3298 10.5589 18.1889 11.1094 17.9202 11.6002C17.6515 12.091 17.2635 12.5063 16.7921 12.8077C16.9149 13.3553 16.8974 13.9251 16.7413 14.4642C16.5852 15.0033 16.2954 15.4942 15.899 15.8915C15.5026 16.2887 15.0122 16.5795 14.4735 16.7367C13.9347 16.894 13.365 16.9126 12.8171 16.791C12.5161 17.2642 12.1005 17.6538 11.6089 17.9238C11.1173 18.1937 10.5655 18.3352 10.0046 18.3352C9.44376 18.3352 8.89197 18.1937 8.40034 17.9238C7.90871 17.6538 7.49314 17.2642 7.19211 16.791C6.64447 16.9138 6.0747 16.8963 5.53562 16.7402C4.99654 16.5841 4.5056 16.2943 4.10834 15.8979C3.71107 15.5015 3.42033 15.0111 3.26308 14.4724C3.10582 13.9336 3.08715 13.3639 3.20878 12.816C2.73374 12.5154 2.34246 12.0995 2.07132 11.607C1.80018 11.1146 1.658 10.5615 1.658 9.99935C1.658 9.43717 1.80018 8.88413 2.07132 8.39167C2.34246 7.8992 2.73374 7.48331 3.20878 7.18268Z",
    stroke: "#182553",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeCheck20);
export default __webpack_public_path__ + "static/media/badge-check-20.8617b9e0367dfc154d173301ae4e0fca.svg";
export { ForwardRef as ReactComponent };